import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=051ea559&"
import script from "./Webcam.vue?vue&type=script&lang=js&"
export * from "./Webcam.vue?vue&type=script&lang=js&"
import style0 from "./Webcam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/s21.lmb-willy.de/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VChip,VExpandTransition,VFlex,VHover,VIcon,VImg,VLayout,VSpacer})
